<template>
  <div>
    <div class="virtualPrivateCloudResource-title">
      <div>{{ $t("RAM.AWS.VirtualNetwork.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:virtualPrivateCloudResource:update'
          ]"
          :loading="loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          :loading="modal_loading"
          @click="exportList"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:virtualPrivateCloudResource:export'
          ]"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <virtual-private-cloud-resource-search
      ref="child"
    ></virtual-private-cloud-resource-search>
    <table-virtual-private-cloud-resource></table-virtual-private-cloud-resource>
  </div>
</template>

<script>
import VirtualPrivateCloudResourceSearch from "../vpc/VirtualPrivateCloudResourceSearch";
import TableVirtualPrivateCloudResource from "../vpc/TableVirtualPrivateCloudResource";
import TableElasticResource from "../eip/TableElasticResource";

export default {
  name: "VirtualPrivateCloudResource",
  components: {
    VirtualPrivateCloudResourceSearch,
    TableVirtualPrivateCloudResource
  },
  data() {
    return {
      loading: false,
      modal_loading: false
    };
  },
  methods: {
    update: function() {
      this.loading = true;
      this.$api.resourceManagement
        .updateResource({
          companyId: this.$refs.child.companyId,
          resourceManagement: 2,
          accountType: 0
        })
        .then(res => {
          setTimeout(() => {
            this.loading = false;
            this.$Message.success(this.$t('common.updateSuccess'));
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: this.$t('common.exporting')
      });
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportAWSVpc({
          accountName: this.$refs.child.accountName,
          companyId: this.$refs.child.companyId,
          accountType: 0
        })
        .then(res => {
          let fileName = this.$t('RAM.export.virtualNetwork');
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success(this.$t('common.exportSuccess'));
        });
    }
  }
};
</script>

<style scoped>
.virtualPrivateCloudResource-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  overflow: hidden;
  font-weight: 600;
}
.virtualPrivateCloudResource-title > div:nth-child(1) {
  float: left;
}
.virtualPrivateCloudResource-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/vpc/VirtualPrivateCloudResource.vue